import firebase from "firebase";
import axios from "axios";
import * as constants from "../../constants";

export interface FirebaseWebConfig {
	apiKey: string;
	authDomain: string;
	databaseURL?: string;
	projectId: string;
	storageBucket?: string;
	messagingSenderId?: string;
	appId: string;
	measurementId?: string;
}

/**
 * Fetch a white-label app's Firebase web config from the Verris API.
 * The endpoint is unauthenticated and returns only the web config, so the
 * public /activity pages can resolve the app's project without a logged-in user.
 */
export const fetchAppFirebaseConfig = async (appKey: string): Promise<FirebaseWebConfig> => {
	const response = await axios.get<FirebaseWebConfig>(
		`${constants.BASE_API_URL}live/apps/${encodeURIComponent(appKey)}/firebase`,
		{ timeout: 20000 }
	);
	return response.data;
};

/** Base URL of the white-label app's Cloud Functions `api` express app. */
export const getAppFunctionsUrl = (app: firebase.app.App): string => {
	const { projectId } = app.options as { projectId?: string };
	return `https://us-central1-${projectId}.cloudfunctions.net/api`;
};
